// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"a160766b","426":"73fefb4d","464":"9d3588ca","654":"39734401","666":"a65922c6","753":"52b85e04","787":"6649e53f","869":"d750d1b6","912":"be35a4ce","921":"efa09e0e"}[chunkId] + ".chunk.js";
};